import { PropsWithChildren, ReactElement } from "react";

const JSONSkeleton = (): ReactElement => {
  return (
    <div className="h-80 animate-pulse space-y-2 rounded-xl border border-zinc-700 p-4">
      <div className="space-y-2">
        <div className="h-4 w-24 rounded bg-zinc-700" />
        <div className="pl-4">
          <div className="h-4 w-32 rounded bg-zinc-700" />
        </div>
      </div>

      <div className="mt-4 space-y-2">
        <div className="h-4 w-28 rounded bg-zinc-700" />
        <div className="space-y-2 pl-4">
          <div className="h-4 w-4 rounded bg-zinc-700" />
          <div className="pl-4">
            <div className="h-4 w-20 rounded bg-zinc-700" />
          </div>
          <div className="h-4 w-4 rounded bg-zinc-700" />

          <div className="h-4 w-4 rounded bg-zinc-700" />
          <div className="pl-4">
            <div className="h-4 w-24 rounded bg-zinc-700" />
          </div>
          <div className="h-4 w-4 rounded bg-zinc-700" />
        </div>
      </div>

      <div className="mt-4 space-y-2">
        <div className="h-4 w-16 rounded bg-zinc-700" />
        <div className="pl-4">
          <div className="h-4 w-40 rounded bg-zinc-700" />
        </div>
      </div>

      <div className="h-4 w-4 rounded bg-zinc-700" />
    </div>
  );
};

export const JsonLoadingWrapper = ({
  children,
  loading,
}: PropsWithChildren<{
  loading: boolean;
}>): ReactElement => {
  if (loading) {
    return <JSONSkeleton />;
  } else {
    return <>{children}</>;
  }
};
